/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BuildsIndicator_pipeline$ref = any;
type CreateBuildDialog_pipeline$ref = any;
export type PipelineVisibility = "PRIVATE" | "PUBLIC" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Header_pipeline$ref: FragmentReference;
declare export opaque type Header_pipeline$fragmentType: Header_pipeline$ref;
export type Header_pipeline = {|
  +id: string,
  +name: string,
  +description: ?string,
  +url: string,
  +visibility: PipelineVisibility,
  +archived: boolean,
  +emoji: ?string,
  +color: ?string,
  +organization: {|
    +name: string,
    +slug: string,
    +iconUrl: ?string,
  |},
  +repository: ?{|
    +url: string,
    +provider: ?{|
      +__typename: string,
      +url: ?string,
    |},
  |},
  +permissions: {|
    +pipelineUpdate: {|
      +allowed: boolean,
      +code: ?string,
      +message: ?string,
    |},
    +buildCreate: {|
      +allowed: boolean,
      +code: ?string,
      +message: ?string,
    |},
  |},
  +$fragmentRefs: CreateBuildDialog_pipeline$ref & BuildsIndicator_pipeline$ref,
  +$refType: Header_pipeline$ref,
|};
export type Header_pipeline$data = Header_pipeline;
export type Header_pipeline$key = {
  +$data?: Header_pipeline$data,
  +$fragmentRefs: Header_pipeline$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_pipeline",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iconUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "provider",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PipelinePermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "pipelineUpdate",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "buildCreate",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateBuildDialog_pipeline"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuildsIndicator_pipeline"
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '30f11d13dc3c8aef72c40cafe18f0625';

module.exports = node;
